import { createContext } from 'react';
import type { AccountInfo } from '@azure/msal-browser';
import type { UserProfile } from '../store/authSlice';

export interface AuthContextValue {
  isAuthenticated: boolean;
  isLoading: boolean;
  account: AccountInfo | null;
  userProfile: UserProfile | null;
  tenantBlocked: boolean;
  /** The last sign-in failure as a sentence for the user, or `null`. */
  authError: string | null;
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

/**
 * Split from the provider so the module exports only a context object: a file that mixes
 * a component with other exports defeats react-refresh.
 */
export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
